//Angular
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

//Componentes

import { LoadingSpinnerModule } from "src/app/shared/spinner/loading-spinner.module";
import { HomeAttendanceComponent } from "./pages/home-attendance/home-attendance.component";
import { ModalCheckComponent } from "./components/modal-check/modal-check.component";
import { ModalValidacionComponent } from "./components/modal-validacion/modal-validacion.component";
import { ModalConfirmacionComponent } from "./components/modal-confirmacion/modal-confirmacion.component";
import { SharedModule } from "../shared/shared.module";
import { ThanYouPageComponent } from "./pages/than-you-page/than-you-page.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalRegisterGuestAttendanceComponent } from "./components/modal-register-guest-attendance/modal-register-guest-attendance.component";

@NgModule({
  declarations: [
    HomeAttendanceComponent,
    ModalCheckComponent,
    ModalValidacionComponent,
    ModalConfirmacionComponent,
    ThanYouPageComponent,
    ModalRegisterGuestAttendanceComponent,
  ],
  exports: [
    HomeAttendanceComponent,
    ModalCheckComponent,
    ModalValidacionComponent,
    ThanYouPageComponent,
    ModalRegisterGuestAttendanceComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    LoadingSpinnerModule,
    SharedModule,
    NgbModule,
  ],
})
export class AttendanceRecordModule {}
